
import OTIF from './OTIF/OTIF';
import ScanningOff from './stillage-scanning/ScanningOff';
import Remakes from './remakes/Remakes';
import Backlog from './discrepancies/Backlog';
import Shelled from './shelled/Shelled';
import BIT from './bit/BIT';
import CoQ from './coq/CoQ';
import TripleLamTough from './tripleLamTough/TripleLamTough';
import DisputeSummary from './dispute-summary/DisputeSummary';
import OtherIssues from './other-issues/OtherIssues';
import { fetchOTIF } from '../../../slices/glassDashboard/otifSlice';
import { fetchCoq } from '../../../slices/glassDashboard/coqSlice';
import { fetchRemakes } from '../../../slices/glassDashboard/remakeslice';
import { fetchBacklog } from '../../../slices/glassDashboard/backlogSlice';
import { fetchBit } from '../../../slices/glassDashboard/bitSlice';
import { fetchShelled } from '../../../slices/glassDashboard/shelledSlice';
import { fetchDisputes } from '../../../slices/glassDashboard/disputeSlice';
import { fetchOtherIssues } from '../../../slices/glassDashboard/otherIssues';
import { fetchStillage } from '../../../slices/glassDashboard/stillages';
import { fetchCoqYear } from '../../../slices/glassDashboard/coqYearSlice';

export const WIDGET_CONFIG = [
    {
        id: 'otif',
        component: OTIF,
        allowedSuppliers: [51, 71],
        fetchActions: [fetchOTIF],
    },
    {
        id: 'coq',
        component: CoQ,
        allowedSuppliers: [51, 71],
        fetchActions: [fetchCoq, fetchCoqYear],
    },
    {
        id: 'scanning-off',
        component: ScanningOff,
        allowedSuppliers: [51],
        fetchActions: [fetchStillage]
    },
    {
        id: 'remakes',
        component: Remakes,
        allowedSuppliers: [51, 71],
        fetchActions: [fetchRemakes]
    },
    {
        id: 'other-issues',
        component: OtherIssues,
        allowedSuppliers: [51, 71],
        fetchActions: [fetchOtherIssues]
    },
    {
        id: 'bit',
        component: BIT,
        allowedSuppliers: [51, 71],
        fetchActions: [fetchBit]
    },
    {
        id: 'shelled',
        component: Shelled,
        allowedSuppliers: [51, 71],
        fetchActions: [fetchShelled]
    },
    {
        id: 'backlog',
        component: Backlog,
        allowedSuppliers: [51],
        fetchActions: [fetchBacklog]
    },
    {
        id: 'triple-lam-tough',
        component: TripleLamTough,
        allowedSuppliers: [51],
        fetchActions: [fetchOTIF]
    },
    {
        id: 'dispute-summary',
        component: DisputeSummary,
        allowedSuppliers: [51],
        fetchActions: [fetchDisputes]
    },
];